<template>
  <div
    class="generic-headline"
    :class="`generic-headline-${color}`"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'generic-headline-container',
  props: {
    color: {
      type: String,
      default: 'primary',
    },
  },
};
</script>

<style lang="scss" scoped>
.generic-headline {
  flex: 1 1;
  position: relative;
  padding: 16px;
  overflow: hidden;
  border-radius: 4px;
  border-style: solid;
  border-width: 1px;

  &-blue {
    border-color: $clr-generic-headline-border-blue;
    background-color: $clr-generic-headline-background-blue;
  }

  &-orange {
    border-color: $clr-generic-headline-border-orange;
    background-color: $clr-generic-headline-background-orange;
  }
}
</style>
